var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "mobile-page", style: _vm.boxStyle }, [
        _c(
          "div",
          { staticClass: "advert" },
          [
            _vm.style === 0
              ? _vm._l(_vm.picList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "advertItem01 acea-row" },
                    [
                      item.image
                        ? _c("img", {
                            style: _vm.contentStyle,
                            attrs: { src: item.image },
                          })
                        : _c("div", { staticClass: "empty-box" }, [
                            _c("span", { staticClass: "iconfont icontupian" }),
                          ]),
                    ]
                  )
                })
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }